import Box from '@mui/material/Box';
import ReactFileReader from 'react-file-reader';
import { Button, FormLabel } from '@material-ui/core';
import XLSX from 'xlsx';
import React, { useState } from 'react';
import { Stack } from '@mui/material';

export type DeedFileReaderProps = {
  onChange: (data: unknown[]) => void;
  label: string;
  description?: string;
  buttonStyle?: Record<string, unknown>;
  fileTypes?: string[];
};

export const DeedFileReader = ({
  fileTypes,
  label,
  description,
  buttonStyle,
  onChange,
}: DeedFileReaderProps): JSX.Element => {
  const [fileName, setFileName] = useState('');

  const handleFiles = (files: File[], onChangeDelegate: (row: unknown[]) => void) => {
    const file = files[0];
    const filename = file.name;
    const fileExt = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
    setFileName(filename);
    if (!fileTypes?.includes(fileExt)) {
      onChangeDelegate([]);
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      let rows = [];
      if (fileExt.startsWith('xls')) {
        let binary = '';
        const bytes = new Uint8Array(e.target?.result as ArrayBuffer);
        const length = bytes.byteLength;
        for (let i = 0; i < length; i += 1) {
          binary += String.fromCharCode(bytes[i]);
        }
        // call 'xlsx' to read the file
        const workbook = XLSX.read(binary, {
          type: 'binary',
          cellDates: true,
          cellStyles: true,
        });
        const firstWorksheet = workbook.Sheets[workbook.SheetNames[0]];
        rows = XLSX.utils.sheet_to_json(firstWorksheet, { header: 1 });
      } else {
        rows = (reader.result as string)
          .split('\n')
          .map((row) => (row.indexOf(';') !== -1 ? row.split(';') : row.split(',')));
      }
      if (onChangeDelegate && typeof onChangeDelegate === 'function') {
        onChangeDelegate(rows);
      }
    };

    if (fileExt.startsWith('xls')) {
      reader.readAsArrayBuffer(file);
    } else if (fileExt === 'csv') {
      reader.readAsText(file);
    } else {
      // TODO: Handle more file types as the need arise.
      onChangeDelegate([]);
    }
  };

  return (
    <Box style={{ border: 2, borderStyle: 'dotted', borderColor: '#555566', padding: 10 }}>
      <ReactFileReader
        handleFiles={(files: File[]) => handleFiles(files, onChange)}
        fileTypes={[...(fileTypes || [])]}
      >
        <Stack direction="column" spacing={3}>
          <Box mb={3} textAlign="center">
            {description}
          </Box>
          <Box textAlign="center">
            <FormLabel>{fileName || 'No File Selected'}</FormLabel>
          </Box>
          <Box alignSelf="center">
            <Button
              style={{ marginBottom: 10, display: 'block', ...buttonStyle }}
              type="button"
              color="primary"
            >
              {label || 'Select File'}
            </Button>
          </Box>
        </Stack>
      </ReactFileReader>
    </Box>
  );
};
